import { IApplicationState } from '../../../types/redux';

export const selectPublication = (articleId: number, state: IApplicationState) => ({
  isFetching: state.publications.isFetching,
  isError: state.publications.isError,
  article: state.publications.articles[articleId],
});
